import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { ICallEventSearchFilters, IPhoneCallTag } from 'voxloud-types/dist/models';

@Component({
  selector: 'filter-modal',
  templateUrl: './filter-modal.component.html',
  styleUrls: ['./filter-modal.component.scss']
})
export class FilterModalComponent {
  public filters: ICallEventSearchFilters;
  public tags: IPhoneCallTag[] = [];
  public outputFilters: Subject<ICallEventSearchFilters> = new Subject();

  constructor(
    private modalRef: NgbActiveModal
  ) {}

  public onFiltersChange(outputFilters: ICallEventSearchFilters) {
    this.outputFilters.next(outputFilters);
    this.outputFilters.complete();
    this.close();
  }

  public close() {
    this.modalRef.close();
  }
}
